import React, { Component } from 'react';
import Button from 'react-bootstrap/Button';


export class TestFieldItem extends Component {
  static displayName = TestFieldItem.name;

  //constructor(props) {
  //  super(props);
  //}

  render() {
    return (
      <div className="btn-group" role="group" aria-label="" style={{margin: 1 + 'px'}} >
        <Button variant="secondary" >{this.props.fieldKey}</Button>
        <Button className="btn btn-primary">{this.props.fieldValue}</Button>
      </div>
    );
  }
}
